import * as React from 'react';
import { observer } from 'mobx-react-lite';
import type { DragData } from 'owa-dnd/lib/utils/dragDataUtil';
import {
    setTypeOfItemBeingDragged,
    setShowDropHint,
} from 'owa-calendar-compose-form-store/lib/mutators/fullcomposeviewstate/dragAndDropMutators';
import Droppable from 'owa-dnd/lib/components/Droppable';
import createDropViewState from 'owa-dnd/lib/utils/createDropViewState';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';

export interface FullComposeDroppableContainerProps {
    formId: string;
    children?: React.ReactNode;
}

import styles from './FullComposeDroppableContainer.scss';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

const FullComposeDroppableContainer: React.FunctionComponent<FullComposeDroppableContainerProps> = props => {
    const { formId, children } = props;

    const onDrop = React.useCallback(
        (dragInfo: DragData) => {
            setDataItemType(formId, null);
            setShowDropHint(formId, false);
        },
        [formId]
    );

    const onDragLeave = React.useCallback(() => {
        setDataItemType(formId, null);
        setShowDropHint(formId, false);
    }, [formId]);

    const onDragOver = React.useCallback(
        (dragInfo: DragData) => {
            setDataItemType(formId, dragInfo.itemType);
            setShowDropHint(formId, true);
        },
        [formId]
    );

    return (
        <Droppable
            dropViewState={createDropViewState()}
            onDrop={onDrop}
            onDragLeave={onDragLeave}
            shouldIgnoreTransientOnDragLeave={true}
            bypassActOnDrop={true}
            onDragOver={onDragOver}
            classNames={classNames(styles.composeFormDroppable, 'customScrollBar')}>
            {children}
        </Droppable>
    );
};

export default observer(FullComposeDroppableContainer);

function setDataItemType(formId: string, newValue: string) {
    if (getFullComposeViewState(formId).typeOfItemBeingDragged != newValue) {
        setTypeOfItemBeingDragged(formId, newValue);
    }
}
